import { createSlice } from '@reduxjs/toolkit';
import { fetchSearchProducts } from '../../services';
import { ISearchState } from '../../components/interfaces';

const initialState: ISearchState = {
  results: [],
  status: 'idle',
  error: null,
  materialImages: {},
  skip: 0,
  hasMore: true,
  activeRequestId: null,
};

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    clearSearchResults: (state) => {
      state.results = [];
      state.materialImages = {};
      state.status = 'idle';
      state.error = null;
      state.activeRequestId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSearchProducts.pending, (state, action) => {
        state.status = 'loading';
        state.error = null;
        state.activeRequestId = action.meta.requestId;
      })
      .addCase(
        fetchSearchProducts.fulfilled,
        (state, action) => {
          if (state.activeRequestId !== action.meta.requestId) return;

          state.status = 'succeeded';
          state.results = action.payload.products;
          state.materialImages = {
            ...state.materialImages,
            ...action.payload.materialImages,
          };
          state.activeRequestId = null;
        }
      )
      .addCase(fetchSearchProducts.rejected, (state, action) => {
        if (state.activeRequestId !== action.meta.requestId) return;

        state.status = 'failed';
        state.error = action.payload as string;
        state.activeRequestId = null;
      });
  },
});

export const { clearSearchResults } = searchSlice.actions;
export default searchSlice.reducer;
